// The business's reason for a rejected proof (DR-46, DB-55): one of the four fixed
// codes, labelled through status-label, plus the merchant's optional free-text note
// (required with `other`). Joined as "Label — note" like the design's resubmit layer.
import type { MessageKey } from '@bookingdei/i18n/message-key';
import { statusLabelKeyOrNull } from '@bookingdei/i18n/status-label';
import type { PaymentProof } from '../../mock/seeds/schema-types';

export function rejectReasonLabel(
  p: PaymentProof | undefined,
  t: (k: MessageKey) => string,
): string | null {
  const key = p?.reject_reason_key
    ? statusLabelKeyOrNull('proof_reject_reason', p.reject_reason_key)
    : null;
  return key ? t(key) : null;
}

export function rejectReasonText(
  p: PaymentProof | undefined,
  t: (k: MessageKey) => string,
): string | null {
  const label = rejectReasonLabel(p, t);
  const note = p?.reject_reason?.trim();
  if (label && note) return `${label} — ${note}`;
  return label ?? note ?? null;
}
